import { ConnectorList } from 'components/ConnectorsDashboard/components/ConnectorList/ConnectorList';
import { CreateConnector } from 'components/ConnectorsDashboard/components/CreateConnector/CreateConnector';
import { EditConnector } from 'components/ConnectorsDashboard/components/EditConnector/EditConnector';
import ConnectorsDashboard from 'components/ConnectorsDashboard/ConnectorsDashboard';
import Explorer from 'components/Explorer';
import AddAPI from 'components/IntegrationsDashboard/AddIntegration';
import EditAPI from 'components/IntegrationsDashboard/EditIntegration';
import IntegrationsDashboard from 'components/IntegrationsDashboard/IntegrationsDashboard';
import APIList from 'components/IntegrationsDashboard/Overview';
import Testing from 'components/TestingDashboard/Testing';
import DashboardsLayout from 'pages/dashboards';
import { Navigate, Route, Routes } from 'react-router-dom';

/** Dynamic schema pages */
import { setupDataDog } from 'lib/datadog';
import DynamicSchemaDashboard from 'pages/dynamicSchema/dynamicSchemaDashboard';
import SchemaDetails from 'pages/dynamicSchema/dynamicSchemaDetails';
import DynamicSchemaList from 'pages/dynamicSchema/dynamicSchemaList';

if (window.location.hostname !== 'localhost') {
  setupDataDog(window.location.host);
}

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardsLayout />}>
        <Route index element={<Navigate replace to="api" />} />
        <Route path="connector" element={<ConnectorsDashboard />}>
          <Route index element={<Navigate replace to="list" />} />
          <Route path="list" element={<ConnectorList />} />
          <Route path="add" element={<CreateConnector />} />
          <Route path="edit/:connectorId" element={<EditConnector />} />
        </Route>
        <Route path="api" element={<IntegrationsDashboard />}>
          <Route index element={<Navigate replace to="list" />} />
          <Route path="list" element={<APIList />} />
          <Route path="add" element={<AddAPI />} />
          <Route path="edit/:apiId" element={<EditAPI />} />
        </Route>
        <Route path="explorer" element={<Explorer />} />
        <Route path="schema" element={<DynamicSchemaDashboard />}>
          <Route index element={<Navigate replace to="list" />} />
          <Route path="list" element={<DynamicSchemaList />} />
          <Route path="details" element={<SchemaDetails />} />
        </Route>
        <Route path="Testing" element={<Testing />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />}></Route> /** redirect to home in case of
      unmatched route */
    </Routes>
  );
};

export default App;
